// @ts-nocheck
import styled from "@emotion/styled";
import { Add, Close, Info } from "@mui/icons-material";
import {
  Box,
  Chip,
  IconButton,
  Tooltip,
  Typography,
  Zoom,
} from "@mui/material";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import PropTypes from "prop-types";
import { display, maxWidth } from "@mui/system";

export const CustomIconButton = styled((props) => (
  <IconButton
    inputprops={{
      "aria-label": "weight",
    }}
    {...props}
  />
))(({ theme }) => ({
  color: "white",
}));

export const CustomIconButtonForSheet = styled((props) => (
  <IconButton
    inputprops={{
      "aria-label": "weight",
    }}
    {...props}
  />
))(({ theme }) => ({
  // color: "#5f6368",
  height: "1.1rem",
  width: "1.1rem",
  padding: "0 !important",
  borderRadius: "50%",
  backgroundColor: "#6C6C6C",
  "&:hover": {
    backgroundColor: "#6C6C6C",
  },
  "& svg": {
    fill: "#fff",
  },
}));

export const CustomChip = styled((props) => (
  <Chip
    color="secondary"
    style={{
      color: "white",
      borderRadius: "4px",
      ...(props?.style || {}),
    }}
    size="small"
    deleteIcon={<Close color="primary" />}
    {...props}
  />
))(({ theme }) => ({
  color: "white",
}));

export const CustomAirportChip = styled((props) => (
  <Chip
    color="secondary"
    style={{
      color: "white",
      borderRadius: "1rem",
      ...(props?.style || {}),
    }}
    size="medium"
    deleteIcon={
      <IconButton
        sx={{
          borderRadius: "2rem",
          border: "1.5px solid",
          borderColor: getCssVariableHandler({ variableName: "--white-rgb" }),
          backgroundColor: "transparent",
          height: "1.25rem",
          width: "1.25rem",
        }}
      >
        <Close
          sx={{
            fontSize: "1rem",
          }}
          color="primary"
        />
      </IconButton>
    }
    {...props}
  />
))(({ theme }) => ({
  color: "white",
  border: "1.5px solid",
  borderColor: getCssVariableHandler({ variableName: "--white-rgb" }),
}));

export const CustomInfoButton = styled((props) => (
  <Tooltip
    enterTouchDelay={0}
    title={
      <Box
        container
        style={{
          minWidth: "8vw",
        }}
      >
        {props.header && (
          <Typography fontSize="20px" fontWeight={500} color="primary">
            {props.header}
          </Typography>
        )}
        {props.body && (
          <Typography color="primary" fontWeight={300} fontSize="12px">
            {props.body}
          </Typography>
        )}

        {props?.equipments && (
          <Box display="flex" marginTop={2} gap={1}>
            {props?.equipments.map((eq, i) => (
              <Chip
                size="small"
                style={{
                  color: "#000",
                  borderRadius: "11px",
                  backgroundColor: "#fff",
                  fontSize: "12px",
                }}
                key={i}
                label={eq}
              />
            ))}
          </Box>
        )}
      </Box>
    }
    arrow
    {...props}
    TransitionComponent={Zoom}
    componentsProps={{
      tooltip: {
        sx: {
          maxWidth: "500px",
          wordBreak: "break-word",
        },
      },
    }}
  >
    {/* <img src={infoIcon} alt="" /> */}
    <Info color="primary" />
  </Tooltip>
))(({ theme }) => ({
  color: "white",
  cursor: "pointer",
}));

export const SmallAddButton = ({ onClick, title = "Add" }) => {
  return (
    <CustomIconButton
      sx={{
        borderRadius: "0.25rem",
        backgroundColor: getCssVariableHandler({
          variableName: "--primary-pink-hex",
        }),
        padding: "0.1rem 0.25rem",
        "&:hover": {
          backgroundColor: getCssVariableHandler({
            variableName: "--primary-pink-hex",
          }),
          opacity: "0.8",
        },
      }}
      onClick={onClick}
    >
      <Add sx={{ fontSize: "1.25rem" }} />
      <Typography display={"inline"}>{title}</Typography>
    </CustomIconButton>
  );
};

SmallAddButton.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string,
};